<template>
  <div class="action-timeline">
    <flash-swf :attributes="attr" :flashvars="flashvars"></flash-swf>
  </div>
</template>

<script> 
  // SceneSwf 组件
  import FlashSwf from '@/components/Flash/FlashSwf'

  // 通讯协议
  import protocol from '@/common/scripts/protocol.js'

  export default {
    components: {
      FlashSwf
    },
    props:['timeline_toolbar'],
    data () {
      return {
        attr: {
          id: 'ACTIONTIMELINE-SWF',
        },
        flashvars: {
          assetsUrl: process.env.ACTION_TIMELIME_ASSETS_SWF
        }
      }
    }
  }
</script>

<style lang="stylus">
  .action-timeline
    position: absolute
    top: 0
    right: 0
    left: 0
</style>


// WEBPACK FOOTER //
// ActionTimeline.vue?a6d48546